import BaseApiService from './BaseApiService';

class CompanyApiService extends BaseApiService {
    constructor() {
        super('companies');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.companies ? response.companies : [];
    }
}

export default new CompanyApiService();
